import React, { createContext, useState, useContext, useEffect } from 'react'
import { useAuth } from './AuthProvider'

import { useConfig } from './ConfigProvider';
import { AddUser, EditUser, GetCustomerUsers, GetUserRoles, SendResetPasswordToUser, SetUserIsActiveValue } from '../Services/UserService';
import { toast } from 'react-toastify';

export const UserContext = createContext()

export const useUser = () => {
    return useContext(UserContext);
};

export const UserProvider = ({ children }) => {
    const { authState } = useAuth()
    const { api } = useConfig()
    const [customerUsers, setCustomerUsers] = useState([])
    const [userRoles, setUserRoles] = useState([])
    const [isLoadingUsers, setIsLoadingUsers] = useState(false);
    const [isAddingEditingCustomerUser, setIsAddingEditingCustomerUser] = useState(false);

    useEffect(() => {
        if (authState.custId && authState.custId !== '' && authState.custId !== ' ') {
            handleGetCustomerUsers()
            handleGetUserRoles()
        }
    }, [api, authState.custId])

    const handleGetCustomerUsers = () => {
        setIsLoadingUsers(true);
        GetCustomerUsers(api, authState.custId).then(res => {
            setCustomerUsers(res.data);
            setIsLoadingUsers(false);
        }).catch(e => {
            console.log(e);
            setIsLoadingUsers(false);
        })
    }


    const addCustomerUser = async (user) => {
        setIsAddingEditingCustomerUser(true)
        try {
            const res = await AddUser(api, user)
            setIsAddingEditingCustomerUser(false)
            handleGetCustomerUsers()
            return res.status
        } catch (error) {
            setIsAddingEditingCustomerUser(false)
            console.log(error)
            return error.response.data
        }
    }

    const updateCustomerUser = async (user) => {
        setIsAddingEditingCustomerUser(true)
        try {
            const res = await EditUser(api, user)
            setIsAddingEditingCustomerUser(false)
            handleGetCustomerUsers()
            return res.status
        } catch (error) {
            setIsAddingEditingCustomerUser(false)
            console.log(error)
            return error.response.data
        }
    }

    const handleGetUserRoles = () => {
        GetUserRoles(api)
            .then(res => {
                setUserRoles(res.data);
            })
            .catch(e => {
                console.log(e);
            })
    }

    const handleUserLockUnlock = (value, userId) => {
        SetUserIsActiveValue(api, value, userId).then(() => {
            handleGetCustomerUsers()
        }).catch(e => {
            console.log(e)
        })
    }

    const handleSendResetPasswordToUser = async (userId) => {
        try {
            await SendResetPasswordToUser(api, userId)
            toast.success("Link do resetu hasła został wysłany.")
        } catch (error) {
            console.log(error)
            toast.error("Nie udało się wysłać linku do resetu hasła.")
        }
    }

    return (
        <UserContext.Provider value={{
            handleGetUserRoles,
            userRoles,
            addCustomerUser,
            customerUsers,
            handleGetCustomerUsers,
            updateCustomerUser,
            isLoadingUsers,
            isAddingEditingCustomerUser,
            handleUserLockUnlock,
            handleSendResetPasswordToUser
        }}>
            {children}
        </UserContext.Provider>
    )
}